(() => {
  if (window.__mgMobileNavigationGeometry) return;
  window.__mgMobileNavigationGeometry = true;
  const root = document.documentElement;
  const mobile = window.matchMedia('(max-width:749px)');
  let frame;
  const measure = () => {
    frame = null;
    if (!mobile.matches) return;
    const nav = document.querySelector('.mg-mobile-nav');
    const navHeight = nav?.getBoundingClientRect().height;
    if (navHeight > 0) root.style.setProperty('--mg-mobile-nav-height', `${Math.ceil(navHeight)}px`);
    const railHeight = document.querySelector('.mg-amazon-float')?.getBoundingClientRect().height;
    if (railHeight > 0) root.style.setProperty('--mg-mobile-float-height', `${Math.ceil(railHeight)}px`);
  };
  const queue = () => { if (frame == null) frame = requestAnimationFrame(measure); };
  let observer;
  try { if (typeof ResizeObserver === 'function') observer = new ResizeObserver(queue); } catch {}
  const bind = () => { document.querySelectorAll('.mg-mobile-nav, .mg-amazon-float').forEach(el => observer?.observe(el)); queue(); };
  window.addEventListener('resize', queue, {passive:true});
  window.addEventListener('pageshow', bind);
  document.addEventListener('shopify:section:load', bind);
  mobile.addEventListener('change', queue);
  bind();
})();
